import { parseFormValue } from '../../../lib/parseFormValue.ts';

export const parseOnlineLink = (eventType?: string, onlineLink?: string) =>
  eventType === 'online' ? parseFormValue(onlineLink) : undefined;
